const config = {
  // apiUrl: "https://staging.lawnpride.com.au/backend/api",
  // turfapiUrl: "https://staging-ps.myhometurf.com.au/backend/api",


  apiUrl: "https://problemsolver.lawnpride.com.au/backend/api",
  turfapiUrl: "https://problemsolver.lawnpride.com.au/backend/api",
  appUrl: "/",
};

export default config;
